import { ApiClient, ApiClientConfig } from "../api-client";
import { coerceToContractAbsoluteBase, DataDumpCallbackContract, DataDumpGrantContract, DataDumpLinksContract, DynamicInputFromContract, withContractBase } from "@yujacorp/verity-api-contract";
import { withDefaultErrorHandler } from "../errors";

export default class DataDumpClient extends ApiClient {
    constructor(config: ApiClientConfig) {
        super(config, {});
    }

    createUploadGrant = withDefaultErrorHandler(async (dynamicInput: DynamicInputFromContract<typeof DataDumpGrantContract>) => {
        const handlers = withContractBase({
            contract: DataDumpGrantContract,
            base: coerceToContractAbsoluteBase(`${this.config.verityOrigin}/api/verity/`),
        })
            .withFetchParams({
                pathParams: dynamicInput.pathParams,
                body: dynamicInput.body,
            })
            .withFetcher(async ({ method, url, body }) => {
                const res = await this.fetch(url, {
                    method,
                    headers: { "Content-Type": "application/json" },
                    body: body ? JSON.stringify(body) : undefined,
                });
                return res.json();
            });

        const data = await handlers.toParsed();
        return data;
    })

    executeUploadCallback = withDefaultErrorHandler(async (dynamicInput: DynamicInputFromContract<typeof DataDumpCallbackContract>) => {
        const handlers = withContractBase({
            contract: DataDumpCallbackContract,
            base: coerceToContractAbsoluteBase(`${this.config.verityOrigin}/api/verity/`),
        })
            .withFetchParams({
                pathParams: dynamicInput.pathParams,
                body: dynamicInput.body,
            })
            .withFetcher(async ({ method, url, body }) => {
                const res = await this.fetch(url, {
                    method,
                    headers: { "Content-Type": "application/json" },
                    body: body ? JSON.stringify(body) : undefined,
                });
                return { ok: res.ok } as { ok: boolean };
            });

        const { ok } = await handlers.toRaw();
        return ok;
    })

    getLinks = withDefaultErrorHandler(async (dynamicInput: DynamicInputFromContract<typeof DataDumpLinksContract>) => {
        const handlers = withContractBase({
            contract: DataDumpLinksContract,
            base: coerceToContractAbsoluteBase(`${this.config.verityOrigin}/api/verity/`),
        })
            .withFetchParams({
                pathParams: dynamicInput.pathParams,
            })
            .withFetcher(async ({ method, url }) => {
                const res = await this.fetch(url, {
                    method,
                    headers: { "Content-Type": "application/json" },
                });
                return res.json();
            });

        return handlers.toParsed();
    })
}
